import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() => ({
  commentEditorContainerEdit: {
    width: '99%',
    marginLeft: '10px',
    display: 'flex',
  },
  commentEditorContainer: {
    width: '99%',
    marginLeft: '10px',
    display: 'flex',
    '& .MuiOutlinedInput-multiline': {
      background: '#F5F5F8',
    },
  },
  arrowIcon: {
    fontSize: '3rem !important',
    color: '#3C419A',
    padding: '0',
  },
  xIcon: {
    padding: 0,
    bottom: '7px',
  },
  commentCollapsedText: {
    width: 0,
    minWidth: 0,
    maxWidth: '100%',
    flex: '1 1 auto',
    boxSizing: 'border-box',
    fontSize: '1rem',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    lineHeight: '1.1876em',
    paddingTop: '6px',
    paddingBottom: '7px',
  },
  actionIcon: {
    color: 'white',
    marginTop: '-20px',
    '&:hover': {
      opacity: '1',
      cursor: 'pointer',
      color: '#3C419A',
    },
    '&:focus': {
      opacity: '1',
    },
    '&:active': {
      opacity: '1',
    },
  },
  disabledAction: {
    position: 'absolute',
    height: '40%',
    width: '40%',
    fill: 'black',
    backgroundColor: 'white',
    borderRadius: '50%',
  },
}));
